import { Output } from "valibot";

import { LocaleSchema } from "shared/schemas";
import { getChatPanelText } from "shared/utils/sourceUtils";

type Props = {
  generationLanguage: Output<typeof LocaleSchema>;
};

function LoadingPlaceholder(props: Props) {
  const { generationLanguage } = props;
  const { loading } = getChatPanelText(generationLanguage);
  return <div className="animate-pulse text-xs">{loading || "Loading..."}</div>;
}

export default LoadingPlaceholder;
